import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const MainAtendimentoPage = createLazyPage(
  () =>
    import('@app/modules/protocols/pages/GestaoChamados/MainAtendimentoPage')
);

const AtendimentoProtocoloPage = createLazyPage(
  () =>
    import(
      '@app/modules/protocols/pages/GestaoChamados/AtendimentoProtocoloPage'
    )
);

const ProtocolsAdminPage = createLazyPage(
  () => import('@app/modules/protocols/pages/Admin/ProtocolsAdminPage')
);

export const protocolRoutes: AppRouteDefinition[] = [
  {
    key: 'main-atendimento',
    path: 'main-atendimento',
    element: <MainAtendimentoPage />,
  },
  {
    key: 'main-atendimento-protocolo',
    path: 'main-atendimento/atendimento-protocolo',
    element: <AtendimentoProtocoloPage />,
  },
  {
    key: 'protocols-admin',
    path: 'protocols-admin',
    element: <ProtocolsAdminPage />,
  },
];
